import { Component, OnInit, Input, TemplateRef, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { IPropertyCard } from '../../shared/models/propertycard';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { AuthService } from '../../shared/auth/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserManagerService } from '../../shared/providers/user-manager.service';
import { IUserInput } from '../../shared/models/UserInputModel';
import { PlaceOfferComponent } from '../../property-listing/place-offer/place-offer.component';
import { FileUploadService } from '../../shared/providers/fileupload.service';
import { PropertyManagementService } from '../../shared/providers/property-management.service';
import { IPlaceOfferUserOutput } from '../../shared/models/PlaceOfferUserOutputModel';
import { IPlaceOfferResultOutputModel } from '../../shared/models/PlaceOfferResultOutputModel';
import { IFileUpload } from '../../shared/models/fileupload';
import { ToastService } from '../../shared/providers/toast.service'
import { IPlaceOfferInputModel } from '../../shared/models/PlaceOfferInputModel';
import { IAddToFavorites } from '../../shared/models/AddToFavoriteInputModel';
import { AddTo1031Exchange } from '../../shared/models/AddTo1031ExchangeModel';
import { IUser } from '../../shared/models/user';
import { Trade1031Service } from '../../shared/providers/Trade1031.service';
import { ValidationService } from '../../shared/providers/validation.service';
import { IExchangeCodeOutputModel } from '../../shared/models/ExchangeCodeOutputModel';
import { ILookUp } from '../../shared/models/LookUpOutputModel';
import { CommonService } from '../../shared/providers/common.service';
import { PropertyListingService } from '../../shared/providers/property-listing.service';
import { SharedService } from '../../shared/providers/shared.service';

@Component({
  selector: 'be-property-card',
  templateUrl: './property-card.component.html',
  styleUrls: ['./property-card.component.css']
})

export class PropertyCardComponent implements OnInit {

  img: string;
  offset: number;
  srcSet = true;
  modalRef: BsModalRef;
  modalRefAddToExchange: BsModalRef;
  placeOfferOutputModel = {} as IPlaceOfferUserOutput;
  placeOfferResultOutputModel = {} as IPlaceOfferResultOutputModel;
  placeOfferInputModel = {} as IPlaceOfferInputModel;
  fileExtensionType: string = "document";
  fileUploadType: string = "single";
  inputFileUpload = {} as IFileUpload;
  @Input() property: IPropertyCard;
  @Output() propertyGuid = new EventEmitter<string>();
  @Input() isFromPrincipalDashboard = false;
  showFileUpload = true;
  isUserLoggedIn = false;
  addToFavorites = {} as IAddToFavorites;
  addTo1031Exchange = {} as AddTo1031Exchange;
  classToBind = 'fav';
  classToBind1031 = "label1031";
  classToBindDislike = 'dislike';
  toolTip = "Suggest Property";
  toolTipFav = "Add to favorites";
  toolTipDisLike = "Dislike";
  user: any;
  isPropertyForSale = true;
  exchangeCodes: IExchangeCodeOutputModel[];
  Exchange1031Id: number;
  groupList: ILookUp[];

  @Output() propertyPriorityChanged: EventEmitter<any> = new EventEmitter<any>();


  constructor(private modalService: BsModalService, private activatedRoute: ActivatedRoute, private authService: AuthenticationService, private router: Router, private _propertyManagerService: PropertyManagementService, private elementRef: ElementRef, private _toastService: ToastService, private _fileUploadService: FileUploadService
    , private trade1031Service: Trade1031Service, private _ValidationService: ValidationService, public _commonService: CommonService, protected _propertyListingService: PropertyListingService, private Shared: SharedService, private _auth0: AuthService) { }

  clearFiles: number = 0;
  public getOfferPlaced(offerPlaced: any): void {

    this.property.OfferPlaced = offerPlaced;
  }

  propGuid = "";
  showDisLike: boolean = false;

  openModal(template: TemplateRef<any>, classes: any, guid) {
    this.authService.isLoggedIn.subscribe(i => { this.isUserLoggedIn = i });
    this.user = this.authService.user;
    if (this.isUserLoggedIn) {
      if (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031)) {
        this.router.navigate(['/place-offer/' + guid]);
      }
      else {
        this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login as a principal user to place an offer", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }

    }
    else {
      this.authService.redirectUserTo('place-offer/' + this.propGuid);
      document.getElementById("openModalButton").click();
    }
  }

  openLoginModal(template: TemplateRef<any>, classes: any, guid) {

    if (this.authService.isAuth0Enabled) {
      this._auth0.login();
    }
    else {
      this.modalRef = this.modalService.show(template, { class: classes });
    }
  };


  selectedFiles: string[] = [];
  loggedInUserRole = "";
  showPlaceOffer = true;
  showAddToExchange = false;
  showAddToFav = false;

  userLoggedIn = false;
  Is1031Property = false;
  Images: string[] = [];
  ngOnInit() {
    this.user = this.authService.user;
    /* this._propertyListingService.GetRemainingTerm(this.property.Id).subscribe(response => {*/
    this.property.Images = [];

    if (this.property.FilePath === undefined || this.property.FilePath === null) {
      this.property.FilePath = '/../../../assets/img/default-property_1.png'
    }
    if (this.property.IsPortfolio) {
      this.getPortfolioImages();
    }
    else {
      this.property.Images?.push(this.property.FilePath);
    }

    this.property.Remaining_Term = this._ValidationService.remainingTermForCardandTables(this.property.LeaseExpiration, this.property.LeaseCommencementDate);
    /* });*/

    var timeNow = new Date();
    //console.log("property-card-start " + timeNow.getMinutes().toString() + ':' + timeNow.getSeconds().toString() + ':' + timeNow.getMilliseconds().toString());
    this.showDisLike = this._propertyListingService.showDisLike;

    if (this._propertyListingService.criteria != undefined) {
      this.isPropertyForSale = this._propertyListingService.criteria.PropertyFor != undefined && this._propertyListingService.criteria.PropertyFor == 602 ? false : true;
    }
    else {
      this.isPropertyForSale = this._propertyListingService.activePropertyTab != undefined && this._propertyListingService.activePropertyTab == 602 ? false : true;
    }
    if (this._propertyListingService.currentView == 3 && this._propertyListingService.activePropertyTab == 601) {
      this.isPropertyForSale = true;
      this.showDisLike = false;
    }


    this.propGuid = this.property.Guid;
    this.img = 'assets/img/default-property_1.png';
    this.offset = 100;
    if (this.showDisLike == true) {
      this.onSetActions();
    }
    else {
      if (this.property.IsFav == 1) {
        this.classToBind = 'favClicked';
        this.toolTipFav = "Remove from favorites";
      }

    }
    this.propDivClass = this.propDivClass.replace('active', '');
    if (this.property.IsViewed == 0) {
      this.propDivClass = 'box';
    }
    else {
      this.propDivClass = 'box unvisited';
    }

    if (this.property.PropertyForId == 602) {
      this.Is1031Property = true;
    }
    else {
      this.Is1031Property = false;
    }


    if (this.property.CharacteristicsId) {
      this.property.capRateText = 'ZCF'
    }
    else {
      this.property.capRateText = 'Cap Rate';
    }


    this.authService.isLoggedIn.subscribe(response => {
      this.isUserLoggedIn = response;
      this.user = this.authService.user;
      if (this.user !== null) {
        this.userLoggedIn = true;
        if (this.authService.IsUserRole(this.authService.UserRole.Admin) || this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || this.authService.IsUserRole(this.authService.UserRole.DataEntryStaff)) {
          this.showPlaceOffer = false;
        }
        if (this.authService.IsUserRole(this.authService.UserRole.Broker) && this.isPropertyForSale == false) {
          this.showAddToExchange = true;
        }
        if (this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
          this.showAddToFav = true;
        }
      }
    });

    this.Shared.propertyCardDivId.subscribe(res => {

      this.propDivClass = this.propDivClass.replace('active', '');
      if (this.property.Id == res) {
        if (this.property.IsViewed == 0) {
          this.propDivClass = this.propDivClass.replace('box', 'box active');
        }
        else {
          this.propDivClass = this.propDivClass.replace('box unvisited', 'box unvisited active');
        }
        this.propClicked = true;
        setTimeout(() => {
          this.setFocus(res);
        }, 100);
      }
    });
  }
  public setFocus(fieldToFocus: number): void {

    let elem = <HTMLInputElement>document.getElementById(fieldToFocus + "_tileDiv");
    let scrollContainer = document.getElementById('map-leftdiv');
    if (elem != null && scrollContainer != null) {
      // console.log(elem.offsetParent.offsetTop);
      //elem.scrollIntoView();
      let parent = <HTMLDivElement>elem.offsetParent;
      scrollContainer.scrollTop = parent.offsetTop;
    }
    else {


    }

  }

  async getPortfolioImages() {
    await this._propertyManagerService.getPortfolioImages(this.property.Id).subscribe(response => {

      if (response != null && response != undefined && response.length > 0) {
        this.property.Images = response.map(x => x);
      }
      else {
        this.property.Images?.push(this.property.FilePath);
      }
    });
  }

  propClicked = false;
  propDivClass = '';
  onSetActions() {
    if (this.property.IsFav == 1) {
      this.classToBind = 'favClicked';
      this.toolTipFav = "Remove from favorites";
      this.classToBind1031 = 'label103155';
    }
    else if (this.property.IsDisliked == 1) {
      this.classToBindDislike = 'dislikedClicked';
      this.toolTipDisLike = "Undo";
      this.classToBind1031 = 'label103155';
    }
    else {
      if (this.property.PropertyForId === 601) {
        this.classToBind = 'fav';
      }
      else {
        this.classToBind = 'favClicked55';
      }
      this.classToBind1031 = 'label103195';
    }
    //if (this.property.Is1031Exchange == 1) {
    //    //this.classToBind1031 = 'label1031-checked';
    //    this.toolTip = "Change trade portfolio";
    //}
  }
  search = "";
  isFav = false;
  isDisliked = false;
  onViewProperty(guid: any) {

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.search = params['search'];
      this.isFav = params['isFav'] != undefined ? true : false;
      this.isDisliked = params['isDisliked'] != undefined ? true : false;

    });

    this.propertyGuid.emit(guid);
    if (this.router.url.indexOf('/viewproperty/') > -1) {
      this.router.navigateByUrl('viewproperty/' + guid + '?prevroute=Property List&link=propertylisting');
    }
    else {
      if (this.isFav) {
        this.router.navigateByUrl('viewproperty/' + guid + '?prevroute=Favorites&link=' + encodeURIComponent(this.router.url));
      }
      else if (this.isDisliked) {
        this.router.navigateByUrl('viewproperty/' + guid + '?prevroute=Disliked&link=' + encodeURIComponent(this.router.url));
      }
      else if (!this._ValidationService.IsinValid(this.search)) {
        this.router.navigateByUrl('viewproperty/' + guid + '?prevroute=Saved Search&link=' + encodeURIComponent(this.router.url));
      }
      else if (this.isFromPrincipalDashboard) {
        this.router.navigateByUrl('viewproperty/' + guid + '?prevroute=Principal Dashboard&link=' + encodeURIComponent(this.router.url));
      }
      else {
        this.router.navigateByUrl('viewproperty/' + guid + '?prevroute=Property List&link=' + encodeURIComponent(this.router.url));
      }
    }
  }

  @ViewChild('addToExchange') addToExchange: TemplateRef<any>;
  addToFav(propertyId: any) {
    this.authService.isLoggedIn.subscribe(i => { this.isUserLoggedIn = i });
    this.user = this.authService.user;
    if (this.isUserLoggedIn) {
      if (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031) || this.authService.IsUserRole(this.authService.UserRole.ExternalBroker)) {
        this.addToFavorites.UserId = this.user.Id;
        this.addToFavorites.PropertyId = propertyId;
        if (this.property.IsFav == 0) {
          if (this.Is1031Property) {
            this.trade1031Service.GetExchangeCode(this.user.Id).subscribe(res => {
              this.exchangeCodes = res;
              if (this.exchangeCodes.length > 1) {
                this.modalRefAddToExchange = this.modalService.show(this.addToExchange, {
                  class: 'panlestyle'
                });
              }
              else {

                this.saveAddToFav();
              }
            });
          }
          else {
            this.saveAddToFav();
          }
        }
        else {
          this.saveAddToFav();
        }
      }
      else {
        this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login as a principal to mark as favorite.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    }
    else {
      this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to mark as favorite.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
  }
  private saveAddToFav() {
    this._propertyManagerService.addToFavorite(this.addToFavorites).subscribe(response => {
      if (response) {
        if (response == "1") {
          this.property.IsFav = 1;
          this.classToBind = 'favClicked';
          this.Shared.clickFavourite(true);
          this.toolTipFav = "Remove from favorites";
          this._toastService.addToast({
            title: 'Message', msg: 'This property has been added to your favorites.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
          });
          this.propertyPriorityChanged.emit();
        }
        else if (response == "2") {
          this.property.IsFav = 0;
          this.classToBind = 'fav';
          this.toolTipFav = "Add to favorites";
          this.Shared.clickFavourite(true);
          this._toastService.addToast({
            title: 'Message', msg: 'This property has been removed from your favorites.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
          });
          this.propertyPriorityChanged.emit();
        }
        this.onSetActions();
      }
      else {
        this._toastService.addToast({ title: 'Error Occured', msg: "Please try again letter.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    });
  }

  addToExchangeSave(exchangeId: number[]) {
    this.addToFavorites.ExchangeId = exchangeId;
    this.saveAddToFav();
    this.modalRefAddToExchange.hide();
  }

  savePropertyto1031Exchange() {
    if (this.exchangeCodes.length > 0) {
      if (this.addTo1031Exchange.Exchange1031Id != null && this.addTo1031Exchange.Exchange1031Id != undefined && this.addTo1031Exchange.Exchange1031Id != 0) {
        if (this.addTo1031Exchange.Exchange1031GroupId != null && this.addTo1031Exchange.Exchange1031GroupId != undefined && this.addTo1031Exchange.Exchange1031GroupId != 0) {
          this._propertyManagerService.addTo1031Exchange(this.addTo1031Exchange).subscribe(response => {
            if (response) {
              //this.classToBind1031 = 'label1031-checked';
              //this.toolTip = "Change trade portfolio";
              this._toastService.addToast({
                title: 'Message', msg: 'You successfully added this property to 1031 trade portfolio.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
              })

              this.property.Exchange1031Id = this.addTo1031Exchange.Exchange1031Id;
              this.property.Exchange1031GroupId = this.addTo1031Exchange.Exchange1031GroupId;
            }
            else {
              this.classToBind1031 = 'label1031';
            }

            document.getElementById("closeModal").click();
          });
        }
        else {
          this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please select at least one group.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
      } else {
        this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please select at least one exchange.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    }
    else {
      this._toastService.addToast({ title: 'Warning', msg: "You have no active 1031 Exchanges currently.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
  }
  AddOrEdit = "Suggest Property";
  // Only for Broker
  open1031ExchangeModal(template: TemplateRef<any>, classes: any, propertyId: number, Exchange1031Id: number, Exchange1031GroupId: number) {
    this.authService.isLoggedIn.subscribe(i => { this.isUserLoggedIn = i });
    this.user = this.authService.user;
    if (this.isUserLoggedIn) {
      if (this.authService.IsUserRole(this.authService.UserRole.Broker)) {
        this.authService.isLoggedIn.subscribe(response => {
          if (response) {
            let loggedUserDetails = (JSON.parse(localStorage.getItem('currentUser')));
            this.trade1031Service.GetExchangeCode(loggedUserDetails.Id).subscribe(res => {
              this.exchangeCodes = res;
              //this.exchangeCodes.forEach(item => {
              //    let ProjectedSaleDate = this._ValidationService.convertUTCDateToLocalDate(item.ProjectedSaleDate);
              //    item.ExchangeCode = item.ExchangeCode + " " + this._ValidationService.formatDatetoMMDDYYYY(ProjectedSaleDate);
              //    let SaleDateEnd = this._ValidationService.convertUTCDateToLocalDate(this._ValidationService.addDays(ProjectedSaleDate, 180));
              //    item.ExchangeCode = item.ExchangeCode + "-" + this._ValidationService.formatDatetoMMDDYYYY(SaleDateEnd);
              //});
              if (this.exchangeCodes.length == 1) {
                this.addTo1031Exchange.Exchange1031Id = this.exchangeCodes[0].Id;
              }

              this.addTo1031Exchange.UserId = this.user.Id;
              this.addTo1031Exchange.PropertyId = propertyId;
              this.addTo1031Exchange.Exchange1031Id = Exchange1031Id;
              this.addTo1031Exchange.Exchange1031GroupId = 2200; // Suggested

              if (Exchange1031GroupId == 0) {
                this.addTo1031Exchange.Exchange1031GroupId = 2200; // Suggested
              }

              if (!this.authService.IsUserRole(this.authService.UserRole.Principal1031)) {
                this.addTo1031Exchange.Exchange1031Id = 0;
              }
            });
          }
        });

        this._commonService.getLookupsByTypeId(25).subscribe(response => {
          this.groupList = response.map(o => {
            return {
              id: o.Id, description: o.Description
            };
          });
        });


        if (this.addTo1031Exchange.Exchange1031Id == 0) {
          this.AddOrEdit = "Suggest Property";
        }
        else {
          this.AddOrEdit = "Suggest Property";
          //this.AddOrEdit = "Change trade portfolio";
        }

        this.modalRef = this.modalService.show(template, { class: classes });
      }
      else {
        this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login as a Broker to add your Exchange.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    }
    else {
      this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login as a 1031 Broker to add your Exchange.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
  }

  addToDisliked(propertyId: any) {

    this.authService.isLoggedIn.subscribe(i => { this.isUserLoggedIn = i });
    this.user = this.authService.user;
    if (this.isUserLoggedIn) {
      if (this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031)) {
        this.addToFavorites.UserId = this.user.Id;
        this.addToFavorites.PropertyId = propertyId;

        this._propertyManagerService.addToDisliked(this.addToFavorites).subscribe(response => {
          if (response == "1") {
            this.property.IsDisliked = 1;
            this.classToBindDislike = 'dislikedClicked';
            this.toolTipDisLike = "Undo";
            this.Shared.clickDislike(true);
            this._toastService.addToast({
              title: 'Message', msg: 'This property has been removed from your frontend listing page.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
            })
            this.propertyPriorityChanged.emit();
          }
          else {
            this.property.IsDisliked = 0;
            this.classToBindDislike = 'fav';
            this.toolTipDisLike = "DisLike";
            this.Shared.clickDislike(true);
            this.propertyPriorityChanged.emit();
          }
          this.onSetActions();
        });
      }
      else {
        this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login as a principal to mark as disliked.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    }
    else {
      this._toastService.addToast({ title: 'Unauthorized Action', msg: "Please Login to mark as disliked.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
    }
  }

  gotoPropertyDetails(propertySlug) {
    if (this.isFromPrincipalDashboard) {
      this.router.navigateByUrl('/viewproperty/' + propertySlug + '?prevroute=Principal Dashboard&link=' + this.router.url + '&opentab=tasks');
    }
    else {
      this.router.navigateByUrl('/viewproperty/' + propertySlug + '?prevroute=Property List&link=' + this.router.url + '&opentab=tasks');
    }
  }

  GetPropertyLocationWithCount(location: any) {
    var result = '';
    if (location) {
      var type = location.split(',');
      var count = type.length - 2;
      result = type != null ? type.length >= 2 ? (type[0] + ', ' + type[1] + (count > 0 ? ', ' + count + '+' : '')) : (type[0] + (count > 0 ? ', ' + count + '+' : '')) : '';
      var resultText = type != null ? type.length >= 2 ? (type[0] + ',' + type[1]) : (type[0]) : '';
      if (result) {
        var newLocations = resultText.split(',');
        var resultantLocations = type.filter(val => !newLocations.includes(val));
        if (resultantLocations) {
          this.property.PortfolioLocation = resultantLocations.join(', ');
        }
      }
    }
    return result;
  }

  modalRefShareListing: BsModalRef;
  modalRefSuggestProperties: BsModalRef;
  selectedProperties: IPropertyCard[];
  modalRefOM: BsModalRef;
  openModalForShareListing(template: TemplateRef<any>, classes: any, currentPoperty: IPropertyCard) {
    this.selectedProperties = [];
    currentPoperty.IsSelected = true;
    this.selectedProperties.push(currentPoperty)
    if (this.selectedProperties.length == 0) {
      this._toastService.addToast({
        title: 'Error Occurred',
        msg: 'Please select at least 1 property.',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    } else {
      this.modalRefShareListing = this.modalService.show(template, {
        class: classes,
      });
    }
  }

  sharedOmProperties: number[] = [];
  openModalForShareOM(template: TemplateRef<any>, classes: any, currentPoperty: IPropertyCard) {
    this.sharedOmProperties.push(currentPoperty.Id);
    if (this.sharedOmProperties.length == 0) {
      this._toastService.addToast({
        title: 'Error Occurred',
        msg: 'Please select at least 1 property.',
        timeout: 5000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    } else {
      if (currentPoperty.IsOMExists == 0) {
        this._toastService.addToast({
          title: 'Error Occurred',
          msg: 'OM files not available for the selected properties.',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error',
        });
      } else {
        this.modalRefOM = this.modalService.show(template, { class: classes });
      }
    }
  }

  removeProperty(propertyId: number) {
    this.selectedProperties = [];
    this.sharedOmProperties = [];
  }

  close(propertyId) {
    const allMenus = document.querySelectorAll('.dropdown-property-card');
    allMenus.forEach(menu => {
      if (menu.classList.contains('show') || menu.classList.contains('open')) {
        const toggleLink = menu.querySelector('a');
        if (menu.id != propertyId) {
          if (toggleLink) toggleLink.click();
        }

      }
    });
  }
}
